import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { MailDto } from '@shared/interfaces/dtos/mails';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MailsService extends BaseHttpService {
  protected endPoint: string = 'Connecteurs/iDelibe/Mails';

  public fetchOneMail(mailId: number): Observable<MailDto> {
    return this.http.get<MailDto>(this.buildURL({ idOrSubEndpoint: mailId, apiScope: 'iCourrier' }));
  }
}
